import React from 'react';

import _get from 'lodash/get';

import { Button, Col, DisclaimerText, Input, Popup, Row, SubHeading } from 'reaxl';
import { StandardEmailInput } from 'reaxl-forms';

import { subscribe } from 'axl-config';

export default function EmailSubscribeWithoutAlertForm({
    title,
    user,
    email,
    onEmailInputChange,
    emailSubscribeSend,
}) {

    return (
        <div>
            <SubHeading
                level={3}
                className="text-bold margin-bottom-2"
            >
                {title}
            </SubHeading>

            <Row className="text-left margin-right-0">
                <Col
                    xs={7}
                    className="padding-right-2"
                >
                    <StandardEmailInput
                        maxLength="45"
                        name="emailAddress"
                        placeholder="Email"
                        label=""
                        required
                        value={_get(user, 'emailAddress', email)}
                        onChange={onEmailInputChange}
                    />
                </Col>
                <Col
                    xs={5}
                    componentClass={Button}
                    bsStyle="primary"
                    type="submit"
                    formNoValidate
                    {...emailSubscribeSend}
                    key="subscribe-button"
                >
                    Subscribe
                </Col>
            </Row>

            <DisclaimerText
                withContrast
                size={100}
            >
                <span>
                    {subscribe.inline.privacyStatement.text}
                    <Popup
                        width={600}
                        height={400}
                        url={subscribe.privacyStatement.href}
                    >
                        <span className="text-link margin-left-1">
                            {subscribe.privacyStatement.label}
                        </span>
                    </Popup>
                    .
                </span>
            </DisclaimerText>

            <Input
                type="hidden"
                name="textPot"
                id="textPot"
                layout="elementOnly"
                validations={{
                    minLength: 0,
                }}
            />
        </div>
    );
}
